import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../features/admin/courses/university/Slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../../../../../utils/IDS";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
  image_required = true,
  logo_required = true,
  country_logo_required = true,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const imageFile = watch("image");
  const logoFile = watch("logo");
  const countrylogoFile = watch("country_logo");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      // Always append text fields (they can be updated)
      sendData.append("name", data?.name || "");
      sendData.append("title", data?.title || "");
      sendData.append("description", data?.description || "");
      sendData.append("address", data?.address || "");

      // Only append files IF user selected a new one
      if (data?.logo && data.logo.length > 0) {
        sendData.append("logo", data.logo[0]);
      }
      if (data?.image && data.image.length > 0) {
        sendData.append("image", data.image[0]);
      }
      if (data?.country_logo && data.country_logo.length > 0) {
        sendData.append("country_logo", data.country_logo[0]);
      }
      const res = await dispatch(Update({ id: show, data: sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setShow(false);

        // ✅ open success modal
        setModalsuccessShow(true);
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000); // ⏱️ 3 seconds

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      console.log(res, "resres");
      setDefaultValues({
        id: res?.payload?.data?.id,
        name: res?.payload?.data?.name,
        title: res?.payload?.data?.title,
        description: res?.payload?.data?.description,
        address: res?.payload?.data?.address,
        logo: res?.payload?.data?.logo,
        country_logo: res?.payload?.data?.country_logo,
        image: res?.payload?.data?.image,
      });
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Title"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("title", {
                        required: "Title is required",
                        maxLength: {
                          value: 100,
                          message: "Title cannot exceed 100 characters",
                        },
                        // pattern: {
                        //   value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                        //   message:
                        //     "Title should contain only letters and single spaces (no leading or trailing spaces)",
                        // },
                      })}
                    />
                    {errors?.title && (
                      <Form.Text className="text-danger">
                        {errors?.title?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Description"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("description", {
                        required: "Description is required",
                        // maxLength: {
                        //   value: 100,
                        //   message: "Description cannot exceed 100 characters",
                        // },
                        // pattern: {
                        //   value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                        //   message:
                        //     "Description should contain only letters and single spaces (no leading or trailing spaces)",
                        // },
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors?.description?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Address"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("address", {
                        required: "Address is required",
                        maxLength: {
                          value: 100,
                          message: "Address cannot exceed 100 characters",
                        },
                        // pattern: {
                        //   value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                        //   message:
                        //     "Address should contain only letters and single spaces (no leading or trailing spaces)",
                        // },
                      })}
                    />
                    {errors?.address && (
                      <Form.Text className="text-danger">
                        {errors?.address?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3"></div>
                <div className="col-md-4 mb-3"></div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Logo</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.logo,
                    })}
                    type="file"
                    {...register("logo", {
                      required:
                        logo_required && !defaultValues?.logo
                          ? "Logo is required"
                          : false,
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.logo && (
                    <span className="text-danger">{errors.logo.message}</span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.image,
                    })}
                    type="file"
                    {...register("image", {
                      required:
                        image_required && !defaultValues?.image
                          ? "Image is required"
                          : false,
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field"></Form.Group>
                  <Form.Label>Country Logo</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.country_logo,
                    })}
                    type="file"
                    {...register("country_logo", {
                      required:
                        country_logo_required && !defaultValues?.country_logo
                          ? "Country Logo is required"
                          : false,
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.country_logo && (
                    <span className="text-danger">
                      {errors.country_logo.message}
                    </span>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Logo Preview
                    </Form.Label>
                    {typeof getValues("logo") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("logo")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      logoFile &&
                      logoFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(logoFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Image Preview
                    </Form.Label>
                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="text-center">
                      Image Preview
                    </Form.Label>
                    {typeof getValues("country_logo") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IDS.IMG_URL + getValues("country_logo")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "150px", height: "130px" }}
                        />
                      </div>
                    ) : (
                      countrylogoFile &&
                      countrylogoFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(countrylogoFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
